export const GROUP_COLORS: Record<string, string> = {
  pain: "bg-red-400",
  sleep: "bg-blue-400",
  anxiety: "bg-orange-400",
  nausea: "bg-green-600",
  seizures: "bg-purple-400",
};

export const GROUP_HEX_COLORS: Record<string, string> = {
  pain: "#f87171",
  nausea: "#16a34a",
  seizures: "#c084fc",
  decreased_appetite: "#16a34a",
  difficulty_falling_staying_asleep: "#60a5fa",
  joint_or_arthritis_pain: "#f87171",
  nerve_pain_neuropathy: "#f87171",
  ptsd: "#fb923c",
  stress_anxiety: "#fb923c",
};

export const PROMIS_SYMPTOMS = [
  "pain",
  "nausea",
  "seizures",
  "decreased_appetite",
  "difficulty_falling_staying_asleep",
  "joint_or_arthritis_pain",
  "nerve_pain_neuropathy",
  "ptsd",
  "stress_anxiety",
] as const;
